module.exports = __webpack_public_path__ + "img/13.431cd699.gif";